var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgViewCircle = function SvgViewCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    x: 1,
    y: 1,
    stroke: "#2E3330",
    strokeDasharray: "8 8",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 1.5,
    rx: 18.5
  })));
};
export default SvgViewCircle;